import React, { lazy } from 'react';
import { MapPin, Mail, Phone, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1A1A1A] py-12 md:py-16 border-t border-white/10" data-id="element-48">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-49">
        <div className="grid md:grid-cols-4 gap-8 mb-8 md:mb-12" data-id="element-50">
          {/* Logo & Description */}
          <div className="md:col-span-2 text-center md:text-left" data-id="element-51">
            <div className="flex items-center justify-center md:justify-start mb-4" data-id="element-52">
              <img src="https://cdn.magicpatterns.com/uploads/6mzD2cp15fnbC7PyiPtyAe/Logo-Gerfaj_(1).png" alt="GERFAJ - Arquitectura e Ingeniería" className="h-10 md:h-12 w-auto" width="200" height="48" loading="lazy" decoding="async" data-id="element-53" />
            </div>
            <p className="text-[15px] md:text-[17px] text-white/60 font-normal mb-6 max-w-md mx-auto md:mx-0" style={{
            lineHeight: '1.6'
          }} data-id="element-54">
              Arquitectura de alto rendimiento. Transformando espacios con
              diseño innovador y ejecución impecable.
            </p>
            <div className="space-y-3" data-id="element-55">
              <div className="flex items-center justify-center md:justify-start gap-3 text-[15px] md:text-[17px] text-white/60 font-normal" style={{
              lineHeight: '1.6'
            }} data-id="element-56">
                <Mail className="w-4 h-4 text-[#E8621A]" data-id="element-57" />
                <span data-id="element-58">gerfaj.sas@gmail.com</span>
              </div>
              <div className="flex items-center justify-center md:justify-start gap-3 text-[15px] md:text-[17px] text-white/60 font-normal" style={{
              lineHeight: '1.6'
            }} data-id="element-59">
                <Phone className="w-4 h-4 text-[#E8621A]" data-id="element-60" />
                <span data-id="element-61">+57 (318) 243 4499</span>
              </div>
              <a href="https://www.instagram.com/gerfajarquitectura/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start gap-3 text-[15px] md:text-[17px] text-white/60 hover:text-[#E8621A] font-normal transition-colors" style={{
              lineHeight: '1.6'
            }} data-id="element-62">
                <Instagram className="w-4 h-4 text-[#E8621A]" data-id="element-63" />
                <span data-id="element-64">@gerfajarquitectura</span>
              </a>
            </div>
          </div>

          {/* Locations */}

          {/* Legal Links */}
          <div className="text-center md:text-left" data-id="element-65">
            <h4 className="text-[20px] md:text-[28px] text-white font-semibold mb-4" style={{
            lineHeight: '1.3'
          }} data-id="element-66">
              Legal
            </h4>
            <ul className="space-y-3" data-id="element-67">
              {['Términos y Condiciones', 'Política de Privacidad', 'Política de Cookies', 'Aviso Legal'].map((link, i) => <li key={i} data-id="element-68">
                  <a href="#" className="text-[15px] md:text-[17px] text-white/60 hover:text-[#E8621A] font-normal transition-colors" style={{
                lineHeight: '1.6'
              }} data-id="element-69">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 md:pt-8 border-t border-white/10" data-id="element-70">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-71">
            <p className="text-[11px] md:text-[12px] text-white/40 font-semibold uppercase text-center md:text-left" style={{
            lineHeight: '1',
            letterSpacing: '0.08em'
          }} data-id="element-72">
              © 2026 GERFAJ S.A.S. Todos los derechos reservados.
            </p>
            <p className="text-[11px] md:text-[12px] text-white/40 font-semibold uppercase text-center md:text-right" style={{
            lineHeight: '1',
            letterSpacing: '0.08em'
          }} data-id="element-73">
              NIT: 901.300.914-2
            </p>
          </div>
        </div>
      </div>
    </footer>;
}